import type { KyInstance } from "ky";

import { getLeaderboardTimeframe } from "./getLeaderboardTimeframe";

export interface PacingMetricsResponse {
    totalSessions: number;
    onTargetCount: number;
    onTargetRate: number;
    avgOverageSeconds: number;
}

export const getPacingMetrics = async (client: KyInstance): Promise<PacingMetricsResponse> => {
    const { start, end } = getLeaderboardTimeframe();

    return await client
        .get("v1/metrics/pacing", { retry: 0, searchParams: { start, end } })
        .json<PacingMetricsResponse>();
};
